export default __webpack_public_path__ + "static/media/mainImg.ff47a577.jpg";